import { useSelector } from "react-redux";

function Header()
{

      const selector=  useSelector(state=>state.counter );


    // return (<><h1> Login Form  </h1></>);


}
export default Header;